import styled from 'styled-components';

export const YourInstallationContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 20px;
  padding-right: 20px;
`;
